module.exports = ".equipment-selector-width {\n  width: 243px; }\n"